import React from 'react';
import { UtensilsCrossed } from 'lucide-react';

export default function RestauranteHeader({ totalMesas, ocupadas }) {
  return (
    <div className="rounded-2xl bg-gradient-to-r from-azul-oscuro to-verde-esmeralda p-5 text-white shadow-lg sm:p-6">
      <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-center">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/15">
            <UtensilsCrossed size={26} />
          </div>

          <div>
            <p className="text-sm font-semibold text-white/70">
              Driza Camp
            </p>

            <h1 className="text-2xl font-bold sm:text-3xl">
              Restaurante
            </h1>

            <p className="mt-1 text-sm text-white/75">
              Salón, mesas y atención en un solo lugar.
            </p>
          </div>
        </div>

        <div className="flex gap-3">
          <div className="rounded-xl bg-white/10 px-4 py-3 text-center">
            <div className="text-2xl font-bold">{totalMesas}</div>
            <div className="text-xs font-semibold text-white/70">
              Mesas
            </div>
          </div>

          <div className="rounded-xl bg-white/10 px-4 py-3 text-center">
            <div className="text-2xl font-bold">{ocupadas}</div>
            <div className="text-xs font-semibold text-white/70">
              Ocupadas
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
